;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    iconFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockTwoColumnCarousel from './BlockTwoColumnCarousel';

const query = /* GraphQL */ `
    ${ctaFragment}
    ${linkFragment}
    ${assetFragment}
    ${iconFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockTwoColumnCarousel(preview: $preview, id: $id) {
            __typename
            icon {
                ... on Icon {
                    ...Icon
                }
            }
            eyebrow
            headline
            copy
            cta {
                ...CTA
            }
            imagesCollection {
                items {
                    ...Asset
                }
            }
            colorTheme
            flushTop
            flushBottom
            imageOnLeft
            anchorId
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockTwoColumnCarousel },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockTwoColumnCarousel;
}

const BlockTwoColumnCarouselServer = async ({ id }) => {
    const block = await fetchBlock(id);
    return (
        <BlockTwoColumnCarousel
            {...block}
            images={block.imagesCollection.items}
        />
    );
};

export default BlockTwoColumnCarouselServer;
